<template>
  <div class="publicMain">
    <el-row class="btnGroup">
      <!-- 按钮组件 -->
      <el-col :span="24" class="dy-flex">
        <ButtonBox
          type="primary"
          :id="'btn-add'"
          :buttonData="getArgumentDetail('addTil')"
          class="mx-5"
          @click.native="addTssz()"
        ></ButtonBox>
      </el-col>
    </el-row>
    <el-row>
      <!-- 动态表格组件 -->
      <TableCommon
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :tableColumns="tableColumns"
        :tableData="tableData"
        :uniqueNum="uniqueNum"
        :reserveSelection="reserveSelection"
        :cellStyle="$store.state.cellStyle"
        :headerCellStyle="$store.state.headerCellStyle"
        @handleClickFun="handleClickFun"
        :spanMethod="spanMethod"
      ></TableCommon>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" width="600px" @close="handleClose">
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size:16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-form
        :model="ruleForm"
        :rules="xtRules"
        ref="xtRuleForm"
        label-width="100px"
        size="small"
        class="pa-0"
      >
        <p class="fw-bold pb-5">{{ $t("common.xtxx") }}</p>
        <el-card>
          <el-form-item label="系统编号" prop="sysbh" class="formClass">
            <el-input
              :disabled="disabledFlg"
              v-model="ruleForm.sysbh"
              @keyup.native="myOnkeyUp(ruleForm.sysbh.toLowerCase())"
            ></el-input>
          </el-form-item>
          <el-form-item label="系统名称" prop="sysname">
            <el-input
              :disabled="disabledFlg"
              v-model="ruleForm.sysname"
            ></el-input>
          </el-form-item>
          <el-form-item label="系统简介" prop="sysjj">
            <el-input
              type="textarea"
              v-model="ruleForm.sysjj"
            >
            </el-input>
          </el-form-item>
        </el-card>
      </el-form>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="185px"
        size="small"
        class="pa-0"
      >
        <p class="fw-bold py-5">{{ $t("common.jkxx") }}</p>
        <el-card>
          <template v-for="item in ruleForm.jkxx">
            <el-form-item :key="item.jk" :label="item.jk" prop="jk">
              <el-input v-model="item.url"> </el-input>
            </el-form-item>
          </template>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">
          {{ $t("common.cancelBtn") }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm"
          >{{ $t("xtcs.saveBtn") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as qhsqgl from "@/api/qhsqgl";
import DialogBox from "@/components/DialogBox.vue";

export default {
  name: "tssz",
  components: { DialogBox },
  computed: {},
  data() {
    return {
      lastQueryCondition: {},
      tabLoading: false,
      conditionData: [], // 查询条件数据
      buttonData: [], // 按钮数据
      currentPage: 1, // 页码
      limit: this.$store.state.dataDisplayNum, // 分页显示条数
      total: 0, // 列表数据量
      pageSizes: this.$store.state.pageSizes, // 分页显示可选择条数
      tableData: [], // 表格数据
      tableColumns: [], // 动态表配置信息
      dialogVisible: false,
      layoutFlg: this.$store.state.pageLayout, // 查询条件布局方式  1: 平铺  2: 略缩图
      uniqueNum: "X116105-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      reserveSelection: true,
      // 定义变量的moduleId、groupId 和 fieldId
      argumentDetail: {},
      argumentConfig: {
        addTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-add",
        },
      },
      jknum: 0,
      dialogTitle: this.$t("common.editBtn"),
      dialogType: true,
      disabledFlg: true,
      ruleForm: {
        sysbh: "",
        sysname: "",
        sysjj: "",
        jkxx: [],
      },
      jkarr: [],
      dialogTitleIcon: "", // 模态框标题图标
      xtRules: {
        sysbh: [{ required: true, message: "请输入系统编号", trigger: "blur" }],
        sysname: [
          { required: true, message: "请输入系统名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 获取数据推送设置
    getSjtssz() {
      qhsqgl.getSjtssz().then((res) => {
        this.tableData = res.data.data;
      });
    },
    getTsjkOption() {
      qhsqgl.getTsjkOption().then((res) => {
        let arr = [];
        arr = res.data.data;
        arr.forEach((item) => {
          this.jkarr.push({ jk: item.label, url: "" });
        });
      });
    },
    // 合并单元格方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex <= 3 || column.property == "operation") {
        if (row.num && row.num > 0) {
          return {
            rowspan: row.num,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // 点击按钮或链接
    handleClickFun(row) {
      if (row.oprationflg == "ists") {
        this.kqsjts(row.row);
      }
      if (row.oprationflg == "iszt") {
        this.issjzt(row.row);
      }
      if (row.oprationflg.en == "edit") {
        this.edit(row.row, row.$index);
      }
      if (row.oprationflg.en == "delete") {
        this.delete(row.row, row.$index);
      }
    },
    // 更改是否开启推送
    kqsjts(row) {
      if (row.ispush) {
        row.ists = "1";
      } else {
        row.ists = "0";
      }
      qhsqgl.setIsts(row).then((res) => {
        if (res.data.code == "200") {
          this.$message.success(res.data.message);
          this.getSjtssz();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 更改是否通过数据中台访问
    issjzt(row) {
      console.log(row);
      qhsqgl.setIsts(row).then((res) => {
        if (res.data.code == "200") {
          this.$message.success(res.data.message);
          this.getSjtssz();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 编辑推送设置
    edit(row, index) {
      this.disabledFlg = true;
      this.dialogType = true;
      this.dialogTitleIcon = "el-icon-edit-outline";
      this.dialogTitle = this.$t("common.editBtn");
      this.ruleForm.sysbh = row.sysbh;
      this.ruleForm.sysname = row.sysname;
      this.ruleForm.sysjj = row.sysjj;
      this.ruleForm.jkxx = [];
      this.tableData.forEach((item) => {
        if (row.sysbh == item.sysbh) {
          this.ruleForm.jkxx.push({ jk: item.jk, url: item.url });
        }
      });
      this.dialogVisible = true;
    },
    // 删除推送设置
    delete(row, index) {
      let _this = this;
      _this
        .$confirm(
          _this.$t("xtcs.deleteContent"),
          _this.$t("xtcs.deleteTitle"),
          {
            distinguishCancelAndClose: true,
            confirmButtonText: _this.$t("common.confirmBtn"),
            cancelButtonText: _this.$t("common.cancelBtn"),
          }
        )
        .then((res1) => {
          qhsqgl.delIsts(row).then((res) => {
            if (res.data.code == "200") {
              _this.$message.success(res.data.message);
              _this.getSjtssz();
            } else {
              _this.$message.error(res.data.message);
            }
          });
        })
        .catch((action) => {});
    },
    // 取消推送设置
    cancel() {
      this.dialogVisible = false;
    },
    // 确认推送设置
    confirm() {
      this.$refs["xtRuleForm"].validate((valid) => {
        if (valid) {
          if (this.dialogType) {
            qhsqgl.setIsts(this.ruleForm).then((res) => {
              if (res.data.code == "200") {
                this.$message.success(res.data.message);
                this.getSjtssz();
              } else {
                this.$message.error(res.data.message);
              }
              this.dialogVisible = false;
            });
          } else {
            qhsqgl.addIsts(this.ruleForm).then((res) => {
              if (res.data.code == "200") {
                this.$message.success(res.data.message);
                this.getSjtssz();
              } else {
                this.$message.error(res.data.message);
              }
              this.dialogVisible = false;
            });
          }
        }
      });
    },
    // 新增推送设置
    addTssz() {
      this.disabledFlg = false;
      this.dialogType = false;
      this.dialogTitleIcon = "el-icon-document-add";
      this.dialogTitle = this.$t("common.addedBtn");
      this.ruleForm.jkxx = this.jkarr;
      this.dialogVisible = true;
    },
    // 获取查询条件信息
    loadQueryConfig() {
      let queryInfo = {
        pageId: "X116105",
      };
      this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        this.argumentDetail = res;
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig(areaCode) {
      let _this = this;
      let tmpData = {};
      let params = {};
      params.pageId = areaCode.split("-")[0];
      params.moduleId = areaCode.split("-")[1];
      params.groupId = areaCode.split("-")[2];
      // 清空表格列配置
      _this.tableColumns = []; // 表格列
      // 异步回调
      _this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        _this.tableColumns = tmpResult;
      });
    },
    handleClose(done) {
      this.$refs["ruleForm"].resetFields();
      this.$refs["xtRuleForm"].resetFields();
      this.ruleForm.sysbh = "";
      this.ruleForm.sysname = "";
      this.ruleForm.sysjj = "";
    },
    /** 自定义字段输入时校验输入类型 */
    myOnkeyUp(eleCode) {
      this.ruleForm.sysbh = this.ruleForm.sysbh.replace(
        /^([a-z]*[A-Z]*).*$/g,
        "$1"
      );
    },
  },
  mounted() {
    let _this = this;
    _this.getTsjkOption();
    _this.loadQueryConfig();
    _this.getPageTableConfig(_this.uniqueNum);
    _this.getSjtssz();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .inputClass .el-input {
  width: 90%;
}
</style>
